import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import { useNavigate, useParams } from 'react-router-dom'
import { Box } from '@mui/material'
import * as Yup from 'yup'

// Local imports
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import AdxActionButton from 'components/reusable/ActionButton/AdxActionButton'
import SubmitDocumentView from './submitDocumentView'

// API services
import {
  useShowLeaveRequest,
  usePutUploadLeaveCreditAttachment,
} from 'services/api/modules/leave/leaveRequest'
import AdxButton from 'components/custom/AdxButton'

const SubmitCreditDocument = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { data: item } = useShowLeaveRequest(params.id)
  const [pageState, setPageState] = useState('SUBMIT_DOCUMENT')

  const mutation = usePutUploadLeaveCreditAttachment()

  const handleCloseModal = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    }
    navigate(-1)
  }

  const validationSchema = Yup.object().shape({
    attachment: Yup.array()
      .min(1, 'Attachment is required')
      .max(1, 'Please upload 1 attachment only'),
  })

  const CustomHeader = () => {
    return (
      <>
        <Box
          sx={{
            px: 2,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: 1,
          }}
        >
          <AdxActionButton
            sx={{
              boxShadow: 'none',
              boxSizing: 'border-box',
              width: '100%',
              height: '40px',
            }}
            icon="add"
            iconColor="alternate.main"
            iconBgColor="alternate.light"
            title="Upload Attachment for Credit Leave"
            description="Submission of proof below will be reviewed and approve to support your credit request."
          />
        </Box>
      </>
    )
  }

  if (pageState === 'SUCCESSFUL_REQUEST') {
    return (
      <AdxInfoModal
        open={true}
        muiIcon="check_circle"
        iconColor="alternate.main"
        title="Leave request submitted"
        subtitle={`Your leave credit attachment has been successfully submitted.`}
        footerButtons
        firstBtnLabel={'Return to dashboard'}
        firstBtnHandle={() => navigate(`/app/leave/leave_credit/overview`)}
      ></AdxInfoModal>
    )
  }
  return (
    <AdxFormModal
      open={true}
      onClose={handleCloseModal}
      handleClose={handleCloseModal}
      disableEscapeKeyDown
      disableAutoFocus
      sx={{
        '&.MuiModal-root': { overflowY: 'auto' },
        paddingY: '20px',
      }}
      sxModal={{
        minWidth: { xs: 'none', sm: 'calc(100vw - 30px)', lg: '620px' },
        width: { xs: 'calc(100vw - 30px)', lg: 'calc(100vw - 780px)' },
        position: 'relative',
        top: '0px',
        left: { xs: '15px', lg: '355px' },
        transform: { xs: 'translate(0, 0)', lg: 'translate(0, 0)' },
      }}
      customHeader={<CustomHeader />}
    >
      <Formik
        // enableReinitialize
        initialValues={{
          file: '',
        }}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          if (pageState === 'SUBMIT_DOCUMENT') {
            const postData = {
              leave_policy_id: item.id,
              attachment: values.file.name,
            }
            mutation.mutate(
              { id: item.id, postData: postData },
              {
                onSuccess: () => setPageState('SUCCESSFUL_REQUEST'),
              }
            )
          }
        }}
      >
        {(formikProps) => (
          <>
            <Form>
              {pageState === 'SUBMIT_DOCUMENT' && (
                <SubmitDocumentView
                  item={item}
                  setPageState={setPageState}
                  formikProps={formikProps}
                  mutation={mutation}
                />
              )}
            </Form>
          </>
        )}
      </Formik>
    </AdxFormModal>
  )
}

export default SubmitCreditDocument
